export const REVIEW = {
    APPROVED: 1,
    PENDING_REVIEW: 2,
    REJECTED: 3
};

export const WITHDRAWAL = {
    COMPLETED: 1,
    PENDING: 2,

};

export const CUSTOM_FIELD={
    TEXT: 1,
    DROPDOWN: 2,
    NUMERIC: 3,
    DATE: 4,
    TEXTAREA: 5,
    MULTISELECT: 6,
    FILE: 7,
    PRODUCT: 1,
    SERVICE: 2,
    VENDOR: 3

}
export const PRODUCT = {

    NORMAL: 1,
    DIGITAL: 2,
    DRAFT: 0,
    SUBMIT: 1,
    FILETYPES:[".jpg", ".jpeg", ".png", ".gif", ".webp", ".tiff", ".bmp"],
    ACTIVE:1,
    PENDING:2,
    REJECTED:3,
    ARCHIVED:4,
    DELETED:5,
}

export const ROLE={
    ACTIVE:1,
    INACTIVE:0,
    DELETED:3,
    ALL:2
}
export const SUBADMIN={
    ACTIVE:1,
    INACTIVE:0,
    DELETED:2,
    ALL:'all'
}

export const PRIVILEGE={
    ADMIN:1,
    SUBADMIN:2
}

export const VENDORPYAMENT ={
    BANKPAYMENT :1,
    UPIPAYMENT :2


    }
export const CUSTOMER ={}

export const RETURN_REQUEST ={
    REQUESTED:1,
    OPEN:2,
    DECLINED:3,
    CLOSED:4,
    DISPOSED:1
}
export const VENDOR_TICKET ={
    AWAITING_ADMIN_REPLY : 1,
    AWAITING_VENDOR_REPLY : 2,
    CLOSED : 3
}

export const SERVICE = {
    FILETYPES:["jpg","jpeg","gif","webp","tiff","bmp","png","pdf","odt","mp3","aac","wav","webm","mp4","mkv","avi"],
    DRAFT: 0,
    ACTIVE:1,
    PENDING:2,
    REJECTED:3,
    ARCHIVED:4,
    DELETED:5,
}

export const CHANGEPASSWORD={
    RESETPASSWORD_UNSET:0,
    RESETPASSWORD_SET:1,
    
}

export const COLLECTION={
    PRODUCT: 1,
    SERVICE: 2,
}

export const CATEGORY={
    PRODUCT: 1,
    SERVICE: 2,
}

export const VENDOR={
    ACTIVE: 1,
    BLOCKED: 0,
    PENDING:2,
    NORMAL_LOGIN:1,
   
}
export const PAGINATIONSIZE={
    MANAGE_PRODUCT: 100
   
}
